import React from 'react'

interface MentionMeLogoProps {
    className?: string
}

export default function MentionMeLogo({ className = '' }: MentionMeLogoProps) {
    return (
        <svg className={className} viewBox="0 0 167.133 30.105" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <clipPath id="clip-path">
                    <rect id="Rectangle_812" width="167.133" height="30.105" fill="none" data-name="Rectangle 812" />
                </clipPath>
            </defs>
            <g id="Group_608" data-name="Group 608" transform="translate(-732 -9773)">
                <g id="Group_144" data-name="Group 144" transform="translate(732 9773)">
                    <g id="Group_143" clipPath="url(#clip-path)" data-name="Group 143">
                        <path
                            id="Path_103"
                            fill="#ff40b4"
                            d="M529.639,28.129a1.468,1.468,0,0,0-2.491-.541,3.441,3.441,0,0,0-.438.808,10.111,10.111,0,0,1-3.185,3.535,8.992,8.992,0,0,1-3.961,1.9,4.557,4.557,0,0,1-5.684-3.426c-.01-.029-.019-.058-.029-.088,4.229-2.138,9.175-7.227,9.826-12.061.5-3.838-2.979-6.178-6.548-4.371-4.873,2.968-6.772,8.954-6.62,14.465-1.776.4-3.016-.71-3.7-2.25-1.246-2.665-1.106-5.695-1.669-8.534a7.349,7.349,0,0,0-.965-2.89,3.27,3.27,0,0,0-3.376-1.262c-3.577.769-5.8,5.811-7.261,8.834.019-2.658.02-5.319-.127-7.974a9.446,9.446,0,0,0-.6-3.294,2.235,2.235,0,0,0-2.363-1.406,2.746,2.746,0,0,0-1.364.537c-3.229,2.35-4.957,7.124-6.219,10.746.062-3.49.119-6.852.152-10.342a1.478,1.478,0,0,0-1.579-1.54c-1.748.215-1.375,1.824-1.427,3.11-.044,6.643-.221,13.279-.582,19.912a3.774,3.774,0,0,0,.283,2.051,1.538,1.538,0,0,0,2.551.034,11.95,11.95,0,0,0,.856-2.862c1.389-5.472,3.036-13.312,6.729-17.755a.285.285,0,0,1,.5.158c.42,4.882.107,9.8.113,14.688-.1,2.061,2.019,3.076,3.217,1.229a16.6,16.6,0,0,0,1.128-2.576,58.415,58.415,0,0,1,2.785-6.174c.561-.962,1.733-3.153,2.981-4.045a.955.955,0,0,1,1.476.546c.163.647.21,1.338.331,1.984.37,2.309.429,4.7,1.232,6.914,1.131,3.334,3.683,5.829,7.414,5.109a7.339,7.339,0,0,0,3.186,4.358,8.037,8.037,0,0,0,4,1.215,9.37,9.37,0,0,0,5.54-1.488,17.169,17.169,0,0,0,4.612-3.995,7.051,7.051,0,0,0,1.32-2.324,1.822,1.822,0,0,0-.043-.938M501.6,16.307l.036.015h0l-.037-.016m16.974.106a1.416,1.416,0,0,1,1.947,1.056c.313,1.81-.3,5.4-7.316,10.054h0c.006-.042,1.462-9.45,5.37-11.11"
                            data-name="Path 103"
                            transform="translate(-362.591 -6.786)"
                        />
                        <path
                            id="Path_104"
                            className="fill-black dark:fill-white"
                            d="M5.287,34.114H0v14.9H5.287V41.9c0-1.656,0-4.183,2.353-4.183S9.994,40.243,9.994,41.9v7.117H15.28V41.9c0-1.772.087-4.067,2.528-4.067,2.236,0,2.178,2.527,2.178,4.067v7.117h5.287v-9.5c0-3.428-1.307-5.9-5.084-5.9a5.691,5.691,0,0,0-5.055,2.847,5.454,5.454,0,0,0-5.084-2.847,5.518,5.518,0,0,0-4.706,2.353H5.287Z"
                            data-name="Path 104"
                            transform="translate(0 -25.428)"
                        />
                        <path
                            id="Path_105"
                            className="fill-black dark:fill-white"
                            d="M114,39.4a3.172,3.172,0,0,1,6.13,0Zm11.039,2.5c0-5.084-2.992-8.279-8.163-8.279-4.852,0-8.25,2.992-8.25,7.959,0,5.142,3.69,7.93,8.628,7.93a9.123,9.123,0,0,0,4.764-1.249,6.082,6.082,0,0,0,2.817-3.864h-5.084a2.643,2.643,0,0,1-2.527,1.366,2.963,2.963,0,0,1-3.312-3.312h11.126Z"
                            data-name="Path 105"
                            transform="translate(-82.154 -25.428)"
                        />
                        <path
                            id="Path_106"
                            className="fill-black dark:fill-white"
                            d="M186.4,34.114h-5.287v14.9H186.4V41.289c0-1.859.61-3.457,2.759-3.457,2.615,0,2.382,2.5,2.382,3.922v7.262h5.287V39.808c0-3.661-1.6-6.188-5.607-6.188a5.155,5.155,0,0,0-4.764,2.411H186.4Z"
                            data-name="Path 106"
                            transform="translate(-136.982 -25.428)"
                        />
                        <path
                            id="Path_107"
                            className="fill-black dark:fill-white"
                            d="M257.154,26.118h2.992V21.76h-2.992V17.287h-5.287V21.76h-1.714v4.358h1.714V36.663h5.287Z"
                            data-name="Path 107"
                            transform="translate(-189.197 -13.074)"
                        />
                        <path
                            id="Path_108"
                            className="fill-black dark:fill-white"
                            d="M301.185,8.686H295.9v14.9h5.287ZM298.541,0A2.963,2.963,0,1,0,301.5,2.963,2.975,2.975,0,0,0,298.541,0"
                            data-name="Path 108"
                            transform="translate(-223.553)"
                        />
                        <path
                            id="Path_109"
                            className="fill-black dark:fill-white"
                            d="M332.574,33.62c-4.794,0-8.976,2.876-8.976,7.959s4.212,7.931,8.976,7.931c4.794,0,8.976-2.877,8.976-7.931,0-5.084-4.183-7.959-8.976-7.959m0,4.59a3.239,3.239,0,0,1,3.4,3.37,3.4,3.4,0,0,1-6.8,0,3.239,3.239,0,0,1,3.4-3.37"
                            data-name="Path 109"
                            transform="translate(-244.745 -25.428)"
                        />
                        <path
                            id="Path_110"
                            className="fill-black dark:fill-white"
                            d="M407.575,34.114h-5.287v14.9h5.287V41.289c0-1.859.61-3.457,2.759-3.457,2.615,0,2.383,2.5,2.383,3.922v7.262H418V39.808c0-3.661-1.6-6.188-5.607-6.188a5.156,5.156,0,0,0-4.764,2.411h-.058Z"
                            data-name="Path 110"
                            transform="translate(-304.26 -25.428)"
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}
